import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-dynamic-html-text',
  template: `
    <div
      [innerHtml]="config?.label"
      class="dynamic-field form-input text-align"
      [hidden]="config?.options?.hidden"
    ></div>
  `,
  standalone: false,
})
export class DynamicHtmlTextComponent extends DynamicItemBaseComponent {}
